module.exports = __webpack_public_path__ + "img/40_38_053_830.ecb3cd28.jpg";